import sessionStore from '~/components2/TokenValidator/store';
import getConfig from '~/config';
import { isCredentialedOrigin } from './transformRequest';

/**
 * Builds a predicate for "this map error means the session is gone": a 401 from one of `bases`.
 *
 * Mapbox's own sprite, glyph and style failures arrive at the same `onError`, so the origin check
 * is what stops a third-party asset error from logging the user out. Exported for unit testing
 * without config.
 */
export function makeIsSessionExpiredMapError(bases: string[]) {
  return (error: unknown): boolean => {
    const { status, url } = (error ?? {}) as { status?: unknown; url?: unknown };
    return status === 401 && typeof url === 'string' && isCredentialedOrigin(url, bases);
  };
}

const config = getConfig();

export const isSessionExpiredMapError = makeIsSessionExpiredMapError([config.tileServerBase, config.apiServerBase]);

/** Builds the handler below, taking the predicate so tests need not match the real config. */
export function makeHandleMapAuthError(isSessionExpired: (error: unknown) => boolean) {
  return (error: unknown): boolean => {
    if (!isSessionExpired(error)) {
      return false;
    }
    sessionStore.expire();
    return true;
  };
}

/** Trips the session-expired dialog on a stale-session map error, reporting whether it did. */
export const handleMapAuthError = makeHandleMapAuthError(isSessionExpiredMapError);
